/**
 * groupLeg display and the date each leg uses for publish / past-date checks.
 * A missing letter is Leg A for the date. The name suffix is shown only when
 * the field is a non-empty string. Breaks stay untagged and keep the
 * appointment-then-schedule date they already used.
 */

export function groupLegLetter(trip) {
  if (!trip) return '';
  const raw = trip.groupLeg ?? trip.group_leg;
  if (raw == null) return '';
  return String(raw).trim();
}

export function clientNameWithLeg(name, trip) {
  const base = name == null || name === '' ? '' : String(name);
  if (trip?.is_break || trip?.isBreakTrip) return base;
  const letter = groupLegLetter(trip);
  if (!letter) return base;
  return `${base} (${letter})`;
}

export function planDateIso(trip) {
  if (!trip) return '';
  if (trip.is_break || trip.isBreakTrip) {
    return trip.appointment_time || trip.appointmentTime || trip.schedule_time || trip.scheduleTime || '';
  }
  const letter = groupLegLetter(trip).toUpperCase();
  const legA = letter === '' || letter === 'A';
  if (legA) {
    return trip.appointment_time || trip.appointmentTime || trip.schedule_time || trip.scheduleTime || '';
  }
  return trip.schedule_time || trip.scheduleTime || trip.appointment_time || trip.appointmentTime || '';
}
